export enum AccountSelectorTarget {
  APP,
  FEEDBACK,
}
